import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-monitor\"><defs><style></style></defs><path d=\"M64 64v576h832V64H64zM0 0h960v704H0V0z\" /><path d=\"M192 896h576v64H192zm256-256h64v256h-64z\" /><path d=\"M479.232 561.604l309.99-348.33-47.803-42.548-259.567 291.67-177.895-222.387L163.21 438.605l52.224 37.009 91.622-129.28z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol